module.exports = __webpack_public_path__ + "img/NewMiniBusIcon.a390a3c4.svg";